import { ActionsMenuOption } from '@fox/atoms/src/action-menu/index';
import React from 'react';

export const PIN_ACTION_KEY = 'PushPin';
export const HIDE_ACTION_KEY = 'Hide column';
export const SORT_ACTION_KEY = 'SortByAlpha';
export const FILTER_ACTION_KEY = 'Apply filter';

export const pinAction = (action: () => void, label?: string, pinned?: boolean): ActionsMenuOption => {
	return {
		key: PIN_ACTION_KEY,
		iconName: 'PushPin',
		label: label ?? 'Pin column',
		action
	};
};

export const sortAction = (popover: React.ReactNode): ActionsMenuOption => {
	return {
		key: SORT_ACTION_KEY,
		iconName: 'SortByAlpha',
		label: 'Sort column',
		childPopover: popover
	};
};

export const applyFilterAction = (popover: React.ReactNode): ActionsMenuOption => {
	return {
		key: FILTER_ACTION_KEY,
		iconName: 'FilterAlt',
		label: 'Apply filter',
		childPopover: popover
	};
};
export const applyHideAction = (action: () => void): ActionsMenuOption => {
	return {
		key: HIDE_ACTION_KEY,
		iconName: 'VisibilityOff',
		label: 'Hide column',
		action
	};
};
